import { Token } from '@hero/hero-types';
import { ResponseError, ResponseSuccess } from '@hero/api-services/types';

const hasRefreshSuccessGuard = (
    response: ResponseError<string> | ResponseSuccess<Token> | { statusCode: number; msg: any }
): response is ResponseSuccess<Token> => response.statusCode === 0;

export default hasRefreshSuccessGuard;
